"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var mileages = [
    {
        id: 0,
        title: '0 км',
    },
    {
        id: 10000,
        title: '10 000 км',
    },
    {
        id: 20000,
        title: '20 000 км',
    },
    {
        id: 30000,
        title: '30 000 км',
    },
    {
        id: 40000,
        title: '40 000 км',
    },
    {
        id: 60000,
        title: '60 000 км',
    },
    {
        id: 80000,
        title: '80 000 км',
    },
    {
        id: 100000,
        title: '100 000 км',
    },
];
var getAvailableMileages = function () {
    return mileages;
};
exports.default = getAvailableMileages;
